<template>
  <div>
    <h3 class="om-page-heading">
      <label for="search">{{ $tr('Lista sklepów', 'ShopList') }}</label>
    </h3>
    <form class="om-search flex sb" @submit.prevent="searchAction">
      <input id="search" v-model="searchValue" class="om-search__input fg-20" :placeholder="$tr('Imię i nazwisko lub numer zamówienia', 'ShopList')" :title="$tr('Imię i nazwisko lub numer zamówienia', 'ShopList')">
      <button type="submit" class="om-btn om-search__submit" :placeholder="$tr('', 'ShopList')" @click.prevent="searchAction">
        {{ $tr('Szukaj', 'ShopList') }}
      </button>
    </form>
    <div class="om-list-heading flex sb">
      <div v-if="search != ''" class="flex wrap">
        <div class="om-list-heading__label om-list-heading__label--bright">{{ $tr('Wyniki wyszukiwania:', 'ShopList') }}</div>
        <div class="om-list-heading__label">{{ search }}</div>
        <div class="om-list-heading__label om-list-heading__label--num">({{ filteredCount }})</div>
      </div>
      <div class="flex wrap">
        <label class="om-list-heading__label">
          {{ $tr('Pokaż', 'ShopList') }}
        </label>
        <dropdown v-on:change="changePerPage" :items="itemsPerPage" :default-label="defaultPerPage.name" :default-value="defaultPerPage.value"></dropdown>
      </div><!--<radio :items="periodsRadioFilter"></radio>-->
      <div class="flex wrap">
        <label class="om-list-heading__label">{{ $tr('Wyświetl:', 'ShopList') }}</label>
        <dropdown v-on:change="sortBy" :items="displayOptions" :default-label="displayOptionCurrent ? displayOptionCurrent.name : null" :default-value="displayOptionCurrent ? displayOptionCurrent.value : null"></dropdown>
      </div>

    </div>

    <table v-if="pageContent.length" class="om-table">
      <thead>
        <tr>
          <th>{{ columns.name }}</th>
          <th>{{ columns.code }}</th>
          <th class="td--cen">{{ columns.orders }}</th>
          <th class="td--cen">{{ columns.settings }}</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="item in pageContent">
          <td>
            <div class="font-normal">{{ item.name }}</div>
            <div>
              {{ $tr('ul.', 'ShopList') }} {{ item.address.street }}
              {{ item.address.house }}
              {{ typeof item.address.flat !== 'undefined' && item.address.flat !== '' ? `/ ${item.address.flat}` : '' }}
            </div>
            <div>{{ item.address.postcode }} {{ item.address.city }}</div>
          </td>
          <td>
            {{ item.code }}
          </td>
          <td>
            <div class="flex sb">
              <button class="om-btn om-btn--check" :class="[item.can_return ? 'is-active' : '']" @click.prevent="item.can_return = !item.can_return; updateShop(item)">
                {{ $tr('Zwrot', 'ShopList') }}
              </button>
              <button class="om-btn om-btn--check" :class="[item.can_collect ? 'is-active' : '']" @click.prevent="item.can_collect = !item.can_collect; updateShop(item)">
                {{ $tr('Odbiór', 'ShopList') }}
              </button>
            </div>
          </td>
          <td class="more td--cen">
            <router-link :to="{ name: 'ShopSettings', params: {code: item.code}}">
              <i class="om-ico-tools" aria-hidden="true"></i>
            </router-link>
          </td>
        </tr>
      </tbody>

    </table>
    <div v-else>{{ $tr('Brak wyników wyszukiwania', 'ShopList') }}</div>
    <div class="om-list-footer flex sb">
      <div class="om-add-shop">
        <router-link :to="{ name: 'ShopSettings', params: {code: 'new'}}" tag="button" class="om-btn--add-shop" id="cta-add-new-shop">
          <div class="om-btn__upper-txt">{{ $tr('Dodaj nowy sklep', 'ShopList') }}</div>
          <div class="om-btn__lower-txt">{{ $tr('Utwórz konto dla nowego sklepu', 'ShopList') }}</div>
        </router-link>
      </div>
      <paginator
        :items-per-page="currentPerPage"
        v-on:change="updatePageContent"
        :passive-mode="paginatorPassive"
        :request="request"
        :update-force="requestUpdateForce"></paginator>
    </div>
  </div>
</template>

<script>
  import Paginator from '../reusable/paginator/Paginator.vue'

  export default {
    components: {Paginator},
    name: 'shop-list',
    data () {
      return {
        list: [],
        defaultPerPage: {name: 3, value: 3},
        itemsPerPage: [{name: 3, value: 3}, {name: 6, value: 6}, {name: 12, value: 12}, {name: 24, value: 24}, {name: 48, value: 48}],
        currentPerPage: 3,
        displayOptions: null,
        displayOptionCurrent: null,
        pageContent: [],
        filteredCount: 1,
        fList: null,
        /* table sort functionality */
        sortKey: 'name',

        reverse: false,

        searchValue: '',
        search: '',

        columns: {},

        paginatorPassive: true,
        requestParams: {
          route: 'shop',
          params: {}
        },
        requestUpdateForce: 1,
        activeListing: false
      }
    },
    mounted () {
      this.columns = {
        'name': this.$tr('Nazwa sklepu', 'ShopList'),
        'code': this.$tr('Kod', 'ShopList'),
        'orders': this.$tr('Zamówienia', 'ShopList'),
        'settings': this.$tr('Ustawienia', 'ShopList')
      }
      this.displayOptions = [
        {name: this.$tr('alfabetycznie A-Z', 'ShopList'), value: 'name-ASC'},
        {name: this.$tr('alfabetycznie Z-A', 'ShopList'), value: 'name-DESC'},
        {name: this.$tr('od najnowszych', 'ShopList'), value: 'code-ASC'},
        {name: this.$tr('od najstarszych', 'ShopList'), value: 'code-DESC'}
      ]
      this.displayOptionCurrent = {name: this.$tr('alfabetycznie A-Z', 'ShopList'), value: 'name-ASC'}

      this.$http.get(this.$router.options.getApiRoute('shop'))
        .then((r) => {
          this.list = r.body
          this.filteredCount = this.list.length
          console.log(this.list)
        })
      this.sortBy(this.displayOptionCurrent.value)
    },
    methods: {
      changePerPage (ev) {
        this.currentPerPage = ev
        console.log(ev)
      },
      searchAction () {
        if (this.paginatorPassive) {
          if (this.searchValue !== '') {
            this.requestParams.params['query'] = this.searchValue
            this.activeListing = true
          } else {
            delete this.requestParams.params['query']
            this.activeListing = false
          }
          this.requestUpdateForce++
        } else {
          this.search = this.searchValue
        }
      },
      /* sort value must be made from ORDER_KEY-ORDER_WAY - where '-' is delimiter */
      sortBy (sortKey) {
        let value = sortKey.split('-')
        if (sortKey.indexOf('-') === -1) {
          console.log('Wrong sort value. It must be in format: ORDER_KEY-ORDER_WAY - where \'-\' is delimiter')
          if (typeof this.requestParams.params['order_by'] !== 'undefined') {
            delete this.requestParams.params['order_by']
          }
          if (typeof this.requestParams.params['order_way'] !== 'undefined') {
            delete this.requestParams.params['order_way']
          }
        } else {
          this.requestParams.params['order_by'] = value[0]
          this.requestParams.params['order_way'] = value[1]
        }
        this.requestUpdateForce++
        console.log(value)
      },
      updatePageContent (content) {
        this.pageContent = content
      },
      highlight (words, query) {
        let iQuery = new RegExp(query, 'ig')
        return words.toString().replace(iQuery, (matchedTxt) => {
          return (`<span class="highlight">${matchedTxt}</span>`)
        })
      },
      updateShop (shop) {
        console.log(shop)
        this.$http.post(this.$router.options.getApiRoute('shop-settings', {code: shop.code}), {
          shop: shop
        }).then((resp) => {
          if (resp.ok) {
            this.$alertify.notify(this.$tr('Zaktualizowano pomyślnie', 'ShopList'), 'success', 3)
          } else {
            if (typeof resp.body.errors !== 'undefined' && resp.body.errors.length > 0) {
              for (let e in resp.body.errors) {
                this.$alertify.notify(resp.body.errors[e], 'warning', 3)
              }
            }
          }
        },
        (resp) => {
          console.log('fail:')
          console.log(resp)
        })
      }
    },
    computed: {
      filteredList () {
        let filtered = this.list
        if (this.search !== '') {
          let pattern = new RegExp(this.search, 'i')
          filtered = filtered.filter((item) => {
            return item.firstname.match(pattern) || item.lastname.match(pattern) || item.reference.match(pattern)
          })
        }
        this.filteredCount = filtered.length
        return filtered
      },
      request () {
        return this.requestParams
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "../../assets/scss/settings";
    @import "../../assets/scss/utilities";

  .om-btn--add-shop{
    margin: 28px 0;
    padding: 5px 5px 5px 26px;
    position: relative;
    text-align: left;
    cursor: pointer;
    &:before{
      content: '+';
      font-family: $omni-font-custom;
      font-size: 32px;
      line-height: 20px;
      font-weight: 400;
      color: $omni-color-blue-darker;
      position: absolute;
      left: 0;
      top: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// ShopList.vue?49c155e4